export default "__VITE_ASSET__npSbkaG___"